import { useEffect, useRef } from 'react';

import { PAGES } from '@moniebook-web/types';
import { removeAll } from '@moniebook-web/utils';
import { useNavigate, useSearchParams } from 'react-router';

import { exchangeGhostSessionToken } from '../api/exchange-ghost-session-token';
import { GHOST_SESSION_PAGES, GHOST_SESSION_QUERY_PARAMS } from '../constants';
import { setupGhostSessionTokenInfo } from '../utils';

export const useGhostSessionInit = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const hasExchanged = useRef(false);

    useEffect(() => {
        if (hasExchanged.current) {
            return;
        }

        hasExchanged.current = true;

        const sessionId = searchParams.get(
            GHOST_SESSION_QUERY_PARAMS.SESSION_ID,
        );
        const accessCode = searchParams.get(
            GHOST_SESSION_QUERY_PARAMS.ACCESS_CODE,
        );

        if (!sessionId || !accessCode) {
            navigate(GHOST_SESSION_PAGES.EXPIRED, { replace: true });
            return;
        }

        removeAll();

        exchangeGhostSessionToken(sessionId, accessCode)
            .then((response) => {
                setupGhostSessionTokenInfo(response);
                const broadcastChannel = new BroadcastChannel('auth-channel');
                broadcastChannel.postMessage({
                    senderId: window.BroadcastChannelID,
                });
                broadcastChannel.close();
                navigate(PAGES.HOME, { replace: true });
            })
            .catch(() => {
                navigate(GHOST_SESSION_PAGES.EXPIRED, { replace: true });
            });
    }, [navigate, searchParams]);
};
